import {ResultadoModel} from './resultado.model';

export class PreguntaModel {
  _id:string;
  subcategoria:any = {};
  enunciado:string = "";
  peso:number = 1;
  orden:number = 1;
  resultado:ResultadoModel;
  indice?:string;

  toJSON(){
    return {
      orden: this.orden,
      subcategoria:this.subcategoria._id,
      enunciado: this.enunciado,
      peso: this.peso
    }
  }
}
